<template>
    <div id="left-bar-statistics">
        <ul>
            <li class="menu-title text-center">
                <i class="fa fa-chart-pie"></i>
                {{ $t("LeftBarStatistics.statistics") }}
            </li>
            <li class="has_sub active">
                <router-link to="/statistics/global" class="waves-effect active">
                    <i class="fa fa-tachometer"></i>
                    <span> {{ $t("LeftBarStatistics.global") }} </span>
                </router-link>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
    name: "LeftBarStatistics",
};
</script>

<style lang="scss">
    @import "../../../assets/scss/colors";

    #left-bar-statistics {
        .waves-effect {
            &.active {
                border-left-color: $statistics-color;
                i {
                    color: $statistics-color;
                }
            }
            .waves-ripple {
                background-color: rgba($statistics-color, 0.45) !important;
            }
        }
    }
</style>